import { ApolloLink } from '@apollo/client'
import { GraphQLWsLink } from '@apollo/client/link/subscriptions'
import type { Client } from 'graphql-ws'
import { createClient } from 'graphql-ws'
import { setWsConnectionStatus } from 'src/stores/websocket'
import { getWebsocketUrl } from 'src/utils/config'
import { getToken } from 'src/utils/token'

let currentClient: Client | null = null
let currentLink: GraphQLWsLink | null = null

export const createApolloWsLink = (): ApolloLink => {
  if (typeof window === 'undefined' || typeof WebSocket === 'undefined') {
    return ApolloLink.empty()
  }

  if (currentClient) {
    currentClient.dispose()
  }

  currentClient = createClient({
    url: `${getWebsocketUrl()}/graphql`,
    connectionParams: () => {
      const token = getToken()
      return token ? { token } : {}
    },
    retryAttempts: 3,
    shouldRetry: () => true,
    on: {
      connecting: () => setWsConnectionStatus('connecting'),
      connected: () => setWsConnectionStatus('connected'),
      closed: () => setWsConnectionStatus('closed'),
    },
  })

  currentLink = new GraphQLWsLink(currentClient)
  return currentLink
}

export const restartWsConnection = () => {
  if (currentClient) {
    currentClient.terminate()
    // Client will automatically reconnect due to shouldRetry
  }
}
